import React from "react";
import * as echarts from "echarts";
import closeIcon from "../../minimise_button.png";
import moment from "moment";
import close from "../../minimise_button.png";


export default class CChart_SM extends React.Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.chartInstance = null;
    this.state = {
      options: {
        title: {
          text:this.props.title,
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold',
            color: '#263238',
          },

        
        },
        tooltip: {
          trigger: "axis",
          formatter: (params) => {
            const date = moment(params[0].data[0]).format("DD MMM YYYY");
            const value = params[0].data[1].toFixed(3) + ` ${this.props.units}`;
            return `${date}<br />Value: ${value}`;
          },
        },
        toolbox: {
          feature: {
            magicType: {
              type: ["line", "bar"],
              title: {
                line: "Line Chart",
                bar: "Bar Chart",
              },
            },
            restore: {
              title: "Restore",
            },
            myClose: {
              show: true,
              title: "Minimize",
              icon: `image://${close}`,
              onclick: this.props.toggleVisibleGraphPanel,
            },
          },
        },
        xAxis: {
          type: "time",
          axisLabel: {
            formatter: (value) => {
              if (window.innerWidth > 1000) {
                return moment(value).format("DD MMM YYYY");
              }
              return moment(value).format("MMM YYYY");
            },
          },
          splitLine: {
            show: false,
          },
          name:"Date",
          nameLocation: 'middle',
          nameGap: 25,
          nameTextStyle: {
            fontWeight: 'bold', // Makes the axis name bold
            fontSize: 12, // Adjusts font size (optional)
            color: '#000', // Sets text color (optional)
        },

          nameGap: 25,
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '10%',
        },
        yAxis: {
          type: "value",
          min: 0,
          max: 0.6,
          axisLabel: {
            formatter: (val) => val.toFixed(2),
          },
          splitLine: {
            show: true,
          },
          name: this.props.yAxisTitle,
          nameLocation: 'middle',
          nameGap: 25,
          nameTextStyle: {
            fontWeight: 'bold', // Makes the axis name bold
            fontSize: 12, // Adjusts font size (optional)
            color: '#000', // Sets text color (optional)
        },

          nameGap: 40,
        },
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
        ],
       
        series: [
          {
            name: this.props.name,
            type: "line",
            data: this.props.seriesData,
            smooth: true,
            symbol: 'none',

            lineStyle: {
              width: 2,
              color: '#26a0fc',

            },
            max:100,
          },
        ],
      },
    };
  }

  componentDidMount() {
    this.initChart();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.seriesData !== this.props.seriesData || prevProps.units !== this.props.units) {
      this.updateChart();
    }
  }

  componentWillUnmount() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  }

  initChart = () => {
    this.chartInstance = echarts.init(this.chartRef.current);
    this.chartInstance.setOption(this.state.options);
  };

  updateChart = () => {
    const updatedOptions = {
      ...this.state.options,
      series: [
        {
          name: this.props.name,
          data: this.props.seriesData,
          type: "line",
        },
      ],
    };
    this.chartInstance.setOption(updatedOptions);
  };

  render() {
    return (
  
        <div
          ref={this.chartRef}
          style={{ width: "100%",height:"400px" }}
        ></div>
   
    );
  }
}
